const patientRoutes = [
  // 随访中心
  {
    path: 'follow-up',
    name: 'follow-up',
    meta: {
      title: '随访中心',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      },
      keepAlive: true
    },
    component: resolve => require(['../views/page/AI-follow-up/follow-up.vue'], resolve)
  }
]

export default patientRoutes
